module.exports = __webpack_public_path__ + "static/media/tinyml.89ae4158.svg";